<template>
  <div id="horaires_general">
    <router-link to="/horaires">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Planning général</h2>
    <a
      :class="filteredHoraires.length <= 0?`disabled-link`:``"
      href="javascript:"
      class="mr-3"
      @click="generatePDF()"
    >
      <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
    </a>
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="onePerPageCheck" v-model="filters.onePerPage" />
        <label class="custom-control-label" for="onePerPageCheck">Un jour par page</label>
      </div>
    </div>
    <hr>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date</label>
      <date-picker
        @change="onDateChange"
        @clear="onClearDate"
        type="date"
        format="dd DD/MM/YYYY"
        v-model="filters.date"
      />
      <span class="ml-3">ou</span>
    </div>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date de début</label>
      <date-picker
        :disabled="filters.date !== null"
        name="begindate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.begindate"
      ></date-picker>
      <label class="ml-3" for="enddate">Date de fin</label>
      <date-picker
        :disabled="filters.date !== null"
        name="enddate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.enddate"
      ></date-picker>
      <label class="ml-3" for="site">Site</label>
      <select id="site" name="site" class="form-control custom-select" v-model="filters.site">
        <option selected :value="undefined">-</option>
        <option v-for="site in sites" v-bind:key="site.id" v-bind:value="site.id">{{site.nom}}</option>
      </select>
    </div>
    <p v-if="datealert">
      <img class="imgicon" src="img/warning_yellow.png" />&nbsp;La date de début doit être inférieure à la date de fin
    </p>
    <b-pagination
      v-if="filteredHoraires.length > 0"
      class="mt-3"
      v-model="currentPage"
      :total-rows="filteredHoraires.length"
      :per-page="perPage"
      aria-controls="table-horaires"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="filteredHoraires"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      class="mt-3"
      id="table-horaires"
      v-if="filteredHoraires.length > 0"
      small
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      :tbody-tr-class="rowClass"
    >
      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :width="(field.key === 'id' || field.key === 'fonction' || field.key=== 'site') ? '5%' : ((field.key==='date' || field.key==='seances') ? '15%': (field.key === 'rem' ? '35%' : '20%'))"
        />
        <col width="5%" />
      </template>
      <template v-slot:cell(id)="data">
        <router-link :to="`/horaires/modification/${data.item.id}`">{{data.item.id}}</router-link>
      </template>
      <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
      <template v-slot:cell(employe)="data">
        <span
          v-if="data.item.type === 1"
        ><span v-if="employesById[data.item.id_employe]">{{employesById[data.item.id_employe].nom}} {{employesById[data.item.id_employe].prenom}}</span></span>
        <span v-else>
          <b>QSP</b>
        </span>
      </template>
      <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
      <template v-slot:cell(fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
      <template v-slot:cell(seances)="data">
        <seances :item="data.item" />
      </template>
      <template v-slot:cell(rem)="data">{{data.item.remarque}}</template>
    </b-table>
    <h5 class="pt-5" v-else>Pas d'horaire à signaler...</h5>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import Seances from "../components/Seances";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  data() {
    return {
      sites: [],
      horaires: [],
      perPage: 15,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "id", label: "Référence", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "site", label: "Site", sortable: false },
        { key: "employe", label: "Employé", sortable: false },
        { key: "fonction", label: "Fonction", sortable: false },
        { key: "seances", label: "Séances", sortable: false },
        { key: "rem", label: "Remarque", sortable: false }
      ],
      utils,
      filters: {
        begindate: null,
        enddate: null,
        date: null,
        site: undefined,
        onePerPage: false
      },
      datealert: false,
      employes: [],
      sitesById: [],
      fonctionsById: [],
      employesById: []
      };
  },
  components: { Seances, DatePicker },
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.horaires = (await api.getHorairesGeneral()).data.horaires;
    this.$store.commit("setLoading", false);
  },
  computed: {
    filteredHoraires() {
      return this.horaires.filter(horaire => {
        let ok = true;
        if (ok && this.filters.site !== undefined) {
          if (horaire.id_site !== this.filters.site) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(horaire.date).isBefore(this.filters.begindate, "day")) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(horaire.date).isAfter(this.filters.enddate, "day")) {
            ok = false;
          }
        }
        if (ok && !horaire.visible){
          ok = false;
        }
        return ok;
      });
    }
  },
  methods: {
    onDateChange() {
      if (this.filters.date) {
        this.filters.begindate = this.filters.date;
        this.filters.enddate = this.filters.date;
      }
      this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, "day");
    },
    onClearDate() {
      this.filters.begindate = null;
      this.filters.enddate = null;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.sib) return "table-secondary";
    },
    generatePDF() {
      const filter = {
        begindate: moment(this.filters.begindate).utc(true).toDate(),
        enddate: moment(this.filters.enddate).utc(true).toDate(),
        date: moment(this.filters.date).utc(true).toDate(),
        site: this.filters.site,
        onePerPage: this.filters.onePerPage
      }
      api.pdf(`horairesgeneral`, { filters: filter, limit: false }, `horaire-general`);
    }
  }
};
</script>